export default __webpack_public_path__ + "static/media/location_preview_city_hall.08fd0a80.svg";